// extracted by mini-css-extract-plugin
module.exports = {"Answer":"_17gzWSswibpvwYdl3e3DfJ","label":"_3FGtqAu1c68RiZoWDy23Gm","text":"_3XSwjNOBccK5ieoLMNmeDI","bar":"_4djlvme1Znd7TiG57z-DS","fill":"_1SZ3XSPCmLDgiosUu1fov"};